// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { getWorkflowId, tracer } from '../utils/tracer';
import type { TraceContext } from '@imprivata-cloud/common';

type ImprAgentApi = {
  window: {
    showWindow2: (
      workflowId: string,
      traceContext: TraceContext,
      value: Array<'hide' | 'show' | 'showmaximized'>,
    ) => void;
  };
};

declare global {
  interface Window {
    impr?: ImprAgentApi;
  }
}

export const hideWindow = () => {
  const workflowId = getWorkflowId();
  const currentSpan = tracer.getTracer();
  const traceContext: TraceContext = {
    workflowId,
    // @ts-expect-error - Unknown
    spanContext: currentSpan._spanContext.spanId,
  };
  if (window.impr?.window.showWindow2) {
    window.impr?.window.showWindow2(workflowId, traceContext, ['hide']);
  }
};
